import { api } from '@/lib/api/client'
import type { ApiCategory, CreateCategoryInput, UpdateCategoryInput } from '../model/types'

export const categoriesApi = {
  list()                              { return api.get<ApiCategory[]>('/categories') },
  bySlug(slug: string)                { return api.get<ApiCategory | null>(`/categories/slug/${slug}`) },
  create(input: CreateCategoryInput)  { return api.post<ApiCategory>('/categories', input) },
  update(id: string, input: UpdateCategoryInput) { return api.patch<ApiCategory>(`/categories/${id}`, input) },
  remove(id: string)                  { return api.delete<{ ok: boolean; message?: string }>(`/categories/${id}`) },
}
